import React from 'react';
import Header from 'modules/header/farm/main';
import MyAdvertismentDetail from 'modules/myAdvertisment/myAdvertismentDetail';

const MyAdvertismentDetailContainer = () => {
  return (
    <div>
      <Header title={'مدیریت آگهی'} />
      <MyAdvertismentDetail app={'farm'} />
    </div>
  );
};

export default MyAdvertismentDetailContainer;
